import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appHtmlToText'
})
export class HtmlToTextPipe implements PipeTransform {
  transform(value: string) {
    if (!value) {
      return '';
    } else {
      const newLinesReplacedValue = value.replace(/<(br\s?\/?|\/(div|li))>/gi, '<$1>\n');
      const element = document.implementation.createHTMLDocument('New').body;
      element.innerHTML = newLinesReplacedValue;
      return element.textContent || element.innerText || '';
    }
  }
}
